<template>
    <div class="main">
        <!-- 头部界面 -->
        <div class="bg-top">
            <div>
                <van-button type="primary" color="#666666" size="small" round :style="{opacity:'0.8',margin:'20px',float:'right'}" @click="activityRuleDialog()" v-if="JSON.stringify(message) !== '{}'">活动说明</van-button>
                <van-button type="primary" color="#666666" size="small" round :style="{opacity:'0.0',margin:'20px',float:'right'}" v-if="JSON.stringify(message) === '{}'"></van-button>
            </div>
            <div class="main-title">
                <span>邀请有礼</span>
            </div>
            <div class="main-title-mini">
                <span>{{nextRewardCounter >= 0 ? `再邀请${nextRewardCounter}个朋友${inviteRewardTypeList[inviteRewardType]}即可获得奖励`: (nextRewardCounter == -2 ? `恭喜你，已经获得所有奖品` : `邀请好友${inviteRewardTypeList[inviteRewardType]?inviteRewardTypeList[inviteRewardType]:''}，赢取丰厚奖励`)}}</span>
            </div>
            <div :style="``">
            </div>
            <div class="bg-img">
                <van-image  :src="require('../../assets/images/invite_img.png')"/>
            </div>
        </div>
        <!-- 优惠券 -->
        <div :style="{marginTop:'-1rem',
            width:'100%',
            display:'flex',
            flexDirection:'column',
            alignItems:'center'}">
            <!-- 我的福利 -->
            <van-divider :style="{ 
                width: '60%',
                color: '#BB3804',
                borderColor: '#BB3804', 
                fontWeight: '700',
                margin: '0',
                fontSize: '0.5rem',
                letterSpacing: '0.2rem',
                fontFamily:'幼圆'
            }" v-if="rewardCoupons.length > 0 || rewardExchangeCoupons.length > 0 || rewardGoodExchangeCoupons.length > 0 || inviterMode == 'invite_people_number'">
            {{rewardCoupons.length == 0 && rewardExchangeCoupons.length == 0 && rewardGoodExchangeCoupons.length == 0 ? '我的任务' : '我的福利'}}
            </van-divider>
            <!-- 随机模式 -->
            <span class="remarkText" v-if="baseData.inviter_reward && baseData.inviter_reward.reward_mode=='random'"
            >邀请人数满足后，将随机获得{{baseData.inviter_reward.random_select_number}}件奖品</span>
            <!-- 区间模式 -->
            <div :style="{width: '90%'}" v-if="baseData.inviter_reward && baseData.inviter_reward.reward_mode=='invite_people_number'">
                <van-steps  active-color="#FF9E0F" :active="inviteStepActive" active-icon="gift-o" inactive-icon="gift-o" :style="{
                    borderRadius: '15px',
                    border:'1px solid #BB3804'}">
                    <van-step v-for="(stepItem, stepIndex) in inviteStep" :key="stepIndex">
                        {{stepItem}}
                    </van-step>
                </van-steps>
                <span class="remarkText" style="display:block;">{{inviteStepActive >= (inviteStep.length - 1)? '任务完成！奖励领完啦！' : (rewardCoupons.length > 0 || rewardExchangeCoupons.length > 0 ? '完成任务将获得以下奖励' : '')}}</span>
                <span class="remarkText" style="display:block;" v-if="inviteCount">{{`现已邀请${inviteCount}名好友`}}</span>
            </div>
            <!-- 奖品 -->
            <div v-if="rewardCoupons.length > 0" class="rewardBox">
                <div class="reward" v-for="(rewardItem, rewardIndex) of rewardCoupons" :key="rewardIndex">
                    <div class="reward-icon" :style="{ 'background': 'url(' + require('../../assets/images/reward_icon.png') + ') no-repeat','background-size': '100% 100%'}">
                        <div style="height:60%;text-align:center;color:#FFF;margin-top:5px;font-weight: 500;"> 
                            <span style="font-size:0.4rem;">{{rewardItem.rule.reduce ? '￥':''}}</span>
                            <span style="font-size:0.9rem;">{{rewardItem.rule.reduce ? rewardItem.rule.reduce : rewardItem.rule.discount + '折'}}</span>
                        </div>
                        <div style="text-align:center;color:#FFF;font-size:0.3rem;">
                            {{getRewardText(rewardItem.rule)}}
                        </div>
                    </div>
                    <div class="reward-text">
                        <span class="text" style="color:#3B3B3B">你将可以获得</span>
                        <span class="text" style="font-size:0.4rem;color:#FFA116;">{{rewardItem.name}}{{rewardItem.quantity > 1 ? ' x ' + rewardItem.quantity : ''}}</span>
                        <span class="text" style="color:#999999;">参与活动即可获得</span>
                    </div>
                </div>
            </div>
            <div v-if="rewardExchangeCoupons.length > 0" class="rewardBox">
                <div class="reward" v-for="(rewardItem, rewardIndex) of rewardExchangeCoupons" :key="rewardIndex">
                    <div class="reward-icon" :style="{ 'background': 'url(' + require('../../assets/images/reward_icon.png') + ') no-repeat','background-size': '100% 100%'}">
                        <div style="
                            width : 100%;
                            height : 100%;
                            justify-content : center;
                            color : #FFF;
                            margin-top : 5px;
                            font-weight : 500;
                            display : flex;
                            align-items : center;
                            margin-top : -5px;"> 
                            <span style="font-size:0.5rem;">兑换券</span>
                        </div>
                    </div>
                    <div class="reward-text">
                        <span class="text" style="color:#3B3B3B">你将可以获得</span>
                        <span class="text" style="font-size:0.4rem;color:#FFA116;">{{rewardItem.name}}{{rewardItem.quantity > 1 ? ' x ' + rewardItem.quantity : ''}}</span>
                        <span class="text" style="color:#999999;">参与活动即可获得</span>
                    </div>
                </div>
            </div>
            <div v-if="rewardGoodExchangeCoupons.length > 0" class="rewardBox">
                <div class="reward" v-for="(rewardItem, rewardIndex) of rewardGoodExchangeCoupons" :key="rewardIndex">
                    <div class="reward-icon" :style="{ 'background': 'url(' + require('../../assets/images/reward_icon.png') + ') no-repeat','background-size': '100% 100%'}">
                        <div style="
                            width : 100%;
                            height : 100%;
                            justify-content : center;
                            color : #FFF;
                            margin-top : 5px;
                            font-weight : 500;
                            display : flex;
                            align-items : center;
                            margin-top : -5px;"> 
                            <span style="font-size:0.5rem;">商品券</span>
                        </div>
                    </div>
                    <div class="reward-text">
                        <span class="text" style="color:#3B3B3B">你将可以获得</span>
                        <span class="text" style="font-size:0.4rem;color:#FFA116;">{{rewardItem.name}}{{rewardItem.quantity > 1 ? ' x ' + rewardItem.quantity : ''}}</span>
                        <span class="text" style="color:#999999;">参与活动即可获得</span>
                    </div>
                </div>
            </div>
            <div v-if="rewardLottery.length > 0" class="rewardBox">
                <div class="reward" v-for="(rewardItem, rewardIndex) of rewardLottery" :key="rewardIndex">
                    <div class="reward-icon" :style="{ 'background': 'url(' + require('../../assets/images/reward_icon.png') + ') no-repeat','background-size': '100% 100%'}">
                        <div style="
                            width : 100%;
                            height : 100%;
                            justify-content : center;
                            color : #FFF;
                            margin-top : 5px;
                            font-weight : 500;
                            display : flex;
                            align-items : center;
                            margin-top : -5px;"> 
                            <span style="font-size:0.45rem;">抽奖机会</span>
                        </div>
                    </div>
                    <div class="reward-text">
                        <span class="text" style="color:#3B3B3B">你将可以获得</span>
                        <span class="text" style="font-size:0.4rem;color:#FFA116;">{{rewardItem.name}}的抽奖机会{{rewardItem.quantity > 1 ? ' x ' + rewardItem.quantity : ''}}</span>
                        <span class="text" style="color:#999999;">参与活动即可获得</span>
                    </div>
                </div>
            </div>
            <!-- 好友福利 -->
            <van-divider :style="{ 
                width: '60%',
                color: '#8b0000',
                borderColor: '#8b0000', 
                fontWeight: '700',
                margin: '0',
                fontSize: '0.5rem',
                letterSpacing: '0.2rem',
                fontFamily:'幼圆'
                 }" v-if="rewardCouponsInvited.length > 0 || rewardExchangeCouponsInvited.length > 0">
            好友福利
            </van-divider>
            <span class="remarkText" v-if="baseData.be_invite_reward && baseData.be_invite_reward.reward_mode=='random'">成功邀请后，将随机获得{{baseData.be_invite_reward.random_select_number}}件奖品</span>
            <div v-if="rewardCouponsInvited.length > 0" class="rewardBox">
                <div class="reward" v-for="(rewardItem, rewardIndex) of rewardCouponsInvited" :key="rewardIndex">
                    <div class="reward-icon" :style="{ 'background': 'url(' + require('../../assets/images/reward_icon.png') + ') no-repeat','background-size': '100% 100%'}">
                        <div style="height:60%;text-align:center;color:#FFF;margin-top:5px;font-weight: 500;"> 
                            <span style="font-size:0.4rem;">{{rewardItem.rule.reduce ? '￥':''}}</span>
                            <span style="font-size:0.9rem;">{{rewardItem.rule.reduce ? rewardItem.rule.reduce : rewardItem.rule.discount + '折'}}</span>
                        </div>
                        <div style="text-align:center;color:#FFF;font-size:0.3rem;">
                            {{getRewardText(rewardItem.rule)}}
                        </div>
                    </div>
                    <div class="reward-text">
                        <span class="text" style="color:#3B3B3B">你的好友将可以获得</span>
                        <span class="text" style="font-size:0.4rem;color:#FFA116;">{{rewardItem.name}}{{rewardItem.quantity > 1 ? ' x ' + rewardItem.quantity : ''}}</span>
                        <span class="text" style="color:#999999;">参与活动即可获得</span>
                    </div>
                </div>
            </div>
            <div v-if="rewardExchangeCouponsInvited.length > 0" class="rewardBox">
                <div class="reward" v-for="(rewardItem, rewardIndex) of rewardExchangeCouponsInvited" :key="rewardIndex">
                    <div class="reward-icon" :style="{ 'background': 'url(' + require('../../assets/images/reward_icon.png') + ') no-repeat','background-size': '100% 100%'}">
                        <div style="
                            width : 100%;
                            height : 100%;
                            justify-content : center;
                            color : #FFF;
                            margin-top : 5px;
                            font-weight : 500;
                            display : flex;
                            align-items : center;
                            margin-top : -5px;"> 
                            <span style="font-size:0.5rem;">兑换券</span>
                        </div>
                    </div>
                    <div class="reward-text">
                        <span class="text" style="color:#3B3B3B">你的好友将可以获得</span>
                        <span class="text" style="font-size:0.4rem;color:#FFA116;">{{rewardItem.name}}{{rewardItem.quantity > 1 ? ' x ' + rewardItem.quantity : ''}}</span>
                        <span class="text" style="color:#999999;">参与活动即可获得</span>
                    </div>
                </div>
            </div>
            <div v-if="rewardGoodExchangeCouponsInvited.length > 0" class="rewardBox">
                <div class="reward" v-for="(rewardItem, rewardIndex) of rewardGoodExchangeCouponsInvited" :key="rewardIndex">
                    <div class="reward-icon" :style="{ 'background': 'url(' + require('../../assets/images/reward_icon.png') + ') no-repeat','background-size': '100% 100%'}">
                        <div style="
                            width : 100%;
                            height : 100%;
                            justify-content : center;
                            color : #FFF;
                            margin-top : 5px;
                            font-weight : 500;
                            display : flex;
                            align-items : center;
                            margin-top : -5px;"> 
                            <span style="font-size:0.5rem;">商品券</span>
                        </div>
                    </div>
                    <div class="reward-text">
                        <span class="text" style="color:#3B3B3B">你将可以获得</span>
                        <span class="text" style="font-size:0.4rem;color:#FFA116;">{{rewardItem.name}}{{rewardItem.quantity > 1 ? ' x ' + rewardItem.quantity : ''}}</span>
                        <span class="text" style="color:#999999;">参与活动即可获得</span>
                    </div>
                </div>
            </div>
            <div v-if="rewardLotteryInvited.length > 0" class="rewardBox">
                <div class="reward" v-for="(rewardItem, rewardIndex) of rewardLotteryInvited" :key="rewardIndex">
                    <div class="reward-icon" :style="{ 'background': 'url(' + require('../../assets/images/reward_icon.png') + ') no-repeat','background-size': '100% 100%'}">
                        <div style="
                            width : 100%;
                            height : 100%;
                            justify-content : center;
                            color : #FFF;
                            margin-top : 5px;
                            font-weight : 500;
                            display : flex;
                            align-items : center;
                            margin-top : -5px;"> 
                            <span style="font-size:0.45rem;">抽奖机会</span>
                        </div>
                    </div>
                    <div class="reward-text">
                        <span class="text" style="color:#3B3B3B">你将可以获得</span>
                        <span class="text" style="font-size:0.4rem;color:#FFA116;">{{rewardItem.name}}的抽奖机会{{rewardItem.quantity > 1 ? ' x ' + rewardItem.quantity : ''}}</span>
                        <span class="text" style="color:#999999;">参与活动即可获得</span>
                    </div>
                </div>
            </div>
            <!-- 无奖励 -->
            <div v-if="rewardExchangeCoupons.length == 0 && rewardCoupons.length == 0 && rewardCouponsInvited.length == 0 && rewardExchangeCouponsInvited.length == 0 && rewardGoodExchangeCoupons.length == 0 && rewardGoodExchangeCouponsInvited == 0" style="
                    width : 100%;
                    height : 4rem;
                    justify-content : center;
                    display : flex;
                    align-items : center;">
                <span class="remarkText">
                    没有奖励了~
                </span>
            </div>
        </div>
        <!-- 立即邀请微信好友 -->
        <div style="width:100%;display:flex;margin-top:15px;justify-content:center;">
            <div class="intive-button" @click='shareToMessage()'>
                <svg style="width:27px;height:22px;">
                    <use xlink:href="#icon-weixin"></use>
                </svg>
                <span style="
                    height: 26px;
                    font-size: 0.45rem;
                    font-family: .PingFang SC;
                    font-weight: 550;
                    line-height: 26px;
                    color: #BB3804;
                    margin: 10px;
                    opacity: 1;">
                    立即邀请微信好友
                </span>
            </div>
        </div>
        <!-- 底部菜单 -->
        <div class="other-operate">
            <van-row>
                <van-col span="8" offset="4" @click='shareToTimeline()'>
                    <van-col span="4">
                        <svg style="width:0.3rem;height:0.3rem;">
                            <use xlink:href="#icon-pengyouquan"></use>
                        </svg>
                    </van-col>
                    <van-col span="20">
                        <span class="text">分享到朋友圈</span>
                    </van-col>
                </van-col>
                <van-col span="8" offset="2" @click='showQccode()'>
                    <van-col span="4">
                        <svg style="width:0.3rem;height:0.3rem;">
                            <use xlink:href="#icon-ai-code"></use>
                        </svg>
                    </van-col>
                    <van-col span="20">
                        <span class="text">面对面扫码</span>
                    </van-col>
                </van-col>
            </van-row>
        </div>
        <van-action-sheet v-model="isShowQccode" title="扫码参与活动">
            <div style="width: 250px; margin: auto; padding: 20px 0;">
                <van-image v-if="inviteImg" :src="inviteImg" />
            </div>
        </van-action-sheet>
    </div>
</template>

<script>
    import api from '../../assets/js/api'
    import '../../assets/icon/iconfont'
    import { Dialog } from 'vant'
    import wx from 'weixin-js-sdk'
    export default {
        name: 'InviteCode',
        data(){
            return {
                inviteImg : '',
                rewardCoupons: [],
                rewardExchangeCoupons: [],
                rewardCouponsInvited: [],
                rewardExchangeCouponsInvited: [],
                rewardGoodExchangeCoupons: [],
                rewardGoodExchangeCouponsInvited: [],
                rewardLottery: [],
                rewardLotteryInvited: [],
                params: {
                    companyId: '',
                    path: ''
                },
                isShowQccode: false,
                baseData: {},
                inviteStep: [],
                inviteCount: '',
                inviterMode: '',
                inviteRewardCount: '',
                inviteRewardType: '',
                inviteRewardTypeList: {
                    register: '注册',
                    consume: '消费',
                    recharge: '充值'
                },
                message: {
                },
				defaultShareInfo: {
					describe: '贝林加油送礼啦, 点击查看详情',
					title: '参加活动即可获得奖励, 快来参与',
					img_url: window.location.origin + require('../../assets/images/invite_icon.jpg')
				},
				data: {}
            };
        },
        computed:{
            userId() {
                return this.$store.state.userInfo.id;
            },
            exchangeList() {
                return this.$store.state.systemEnum.company.user_exchange.type
            },
            inviteStepActive() {
                let index = this.inviteStep.indexOf(this.inviteStep.find(item => item > this.inviteCount))
                if (index == -1) {
                    return this.inviteStep.length - 1
                } else if (index == 0) {
                    return -1
                } else return index - 1;
            },
            //获取下次奖励所需人数
            nextRewardCounter() {
                if (this.inviterMode == 'ordinary' || this.inviterMode == 'random') {
                    return this.inviteRewardCount - (this.inviteCount % this.inviteRewardCount)
                }
                if (this.inviterMode == 'invite_people_number') {
                    let next = this.inviteCount + 1;
                    for (var rewardItem of this.baseData.inviter_reward.invite_people_reward) {
                        if (rewardItem.invite_range_start > next) {
                            return rewardItem.invite_range_start - next
                        } else if (rewardItem.invite_range_end > next){
                            return 1
                        }
                    }
                    return -2
                    // if (this.inviteStepActive >= this.inviteStep.length) {
                    //     return -2;
                    // } else return this.inviteRewardCount - this.inviteCount;
                }
                return -1
            }
        },
        created () {
            let self = this;
            this.params.companyId = this.$route.params.companyId;
            api.request('/user/get_invite_info').then(res => {
				let settings = res.data.activity_info && res.data.activity_info.settings;

				wx.ready(function () {
					wx.updateAppMessageShareData({ 
						title: (settings && settings.share_link.title) || self.defaultShareInfo.title,
						desc: (settings && settings.share_link.describe) || self.defaultShareInfo.describe,
						link: `${window.location.origin}/${self.params.companyId}/user/index?invite_user_id=${self.userId}`,
						imgUrl: (settings && settings.share_link.img_url) || self.defaultShareInfo.img_url,
						success: function () {
						}
					});
					wx.updateTimelineShareData({ 
						title: (settings && settings.share_link.title) || self.defaultShareInfo.title,
						desc: (settings && settings.share_link.describe) || self.defaultShareInfo.describe,
						link: `${window.location.origin}/${self.params.companyId}/user/index?invite_user_id=${self.userId}`,
						imgUrl: (settings && settings.share_link.img_url) || self.defaultShareInfo.img_url,
						success: function () {
						}
					})
				});


				self.data = res.data;
                self.inviteImg = res.data.qrcode_url;
                self.inviteCount = res.data.current_invite_count;
                if (!res.data.activity_reward) return
                self.baseData = res.data.activity_reward;
                self.inviteRewardType = res.data.activity_reward.reward_type;
                self.message = res.data.activity_info;
                if (res.data.activity_reward && res.data.activity_reward.inviter_reward && res.data.activity_reward.inviter_reward.reward_mode !== 'none' && res.data.activity_reward.inviter_reward.reward_mode !== 'invite_people_number') {
                    self.inviterMode = res.data.activity_reward.inviter_reward.reward_mode;
                    self.inviteRewardCount = res.data.activity_reward.inviter_reward.invite_number;
                    if (res.data.activity_reward.inviter_reward.reward !== undefined && res.data.activity_reward.inviter_reward.reward.coupons !== undefined) {
                        res.data.activity_reward.inviter_reward.reward.coupons.forEach((item) => {
                            if(item.coupon){
                                self.rewardCoupons.push({
                                    rule: item.coupon.rule,
                                    name: item.coupon.name,
                                    type: 'coupon',
                                    quantity: item.quantity
                                })
                            }
                        })
                    }
                    if (res.data.activity_reward.inviter_reward.reward !== undefined && res.data.activity_reward.inviter_reward.reward.exchange_coupons !== undefined) {
                        res.data.activity_reward.inviter_reward.reward.exchange_coupons.forEach((item) => {
                            if(item.exchange){
                                this.rewardExchangeCoupons.push({
                                    name: item.exchange.name,
                                    type: 'exchange_coupon',
                                    quantity: item.quantity
                                })
                            }
                        })
                    }
                    if (res.data.activity_reward.inviter_reward.reward !== undefined && res.data.activity_reward.inviter_reward.reward.goods_exchange_coupons !== undefined) {
                        res.data.activity_reward.inviter_reward.reward.goods_exchange_coupons.forEach((item) => {
                            if(item.goods_id){
                                this.rewardGoodExchangeCoupons.push({
                                    name: item.good_info.title,
                                    type: 'goods_exchange_coupon',
                                    quantity: item.quantity,
                                    img: 'feaddd50-c365-11eb-8b71-f188f515f7e9'
                                })
                            }
                        })
                    }
                    if (res.data.activity_reward.inviter_reward.reward && res.data.activity_reward.inviter_reward.reward.lottery_activity !== undefined) {
                        res.data.activity_reward.inviter_reward.reward.lottery_activity.forEach((item) => {
                            item.activity_id && this.rewardLottery.push({
                                name: item.activity_info.name,
                                type: 'lottery',
                                quantity: item.frequency,
                                img: 'feaddd50-c365-11eb-8b71-f188f515f7e9'
                            })
                        })
                    }
                }
                if (res.data.activity_reward && res.data.activity_reward.be_invite_reward && res.data.activity_reward.be_invite_reward.reward_mode !== 'none' && res.data.activity_reward.be_invite_reward.reward_mode !== 'invite_people_number') {
                    if (res.data.activity_reward.be_invite_reward.reward !== undefined && res.data.activity_reward.be_invite_reward.reward.coupons !== undefined) {
                        res.data.activity_reward.be_invite_reward.reward.coupons.forEach((item) => {
                            if(item.coupon){
                                this.rewardCouponsInvited.push({
                                    rule: item.coupon.rule,
                                    name: item.coupon.name,
                                    type: 'coupon',
                                    quantity: item.quantity
                                })
                            }
                        })
                    }
                    if (res.data.activity_reward.be_invite_reward.reward !== undefined && res.data.activity_reward.be_invite_reward.reward.exchange_coupons !== undefined) {
                        res.data.activity_reward.be_invite_reward.reward.exchange_coupons.forEach((item) => {
                            if(item.exchange){
                                this.rewardExchangeCouponsInvited.push({
                                    name: item.exchange.name,
                                    type: 'exchange_coupon',
                                    quantity: item.quantity
                                })
                            }
                        })
                    }
                    if (res.data.activity_reward.be_invite_reward.reward !== undefined && res.data.activity_reward.be_invite_reward.reward.goods_exchange_coupons !== undefined) {
                        res.data.activity_reward.be_invite_reward.reward.goods_exchange_coupons.forEach((item) => {
                            if(item.goods_id){
                                this.rewardGoodExchangeCouponsInvited.push({
                                    name: item.good_info.title,
                                    type: 'goods_exchange_coupon',
                                    quantity: item.quantity,
                                    img: 'feaddd50-c365-11eb-8b71-f188f515f7e9'
                                })
                            }
                        })
                    }
                    if (res.data.activity_reward.be_invite_reward.reward && res.data.activity_reward.be_invite_reward.reward.lottery_activity !== undefined) {
                        res.data.activity_reward.inviter_reward.reward.lottery_activity.forEach((item) => {
                            item.activity_id && this.rewardLotteryInvited.push({
                                name: item.activity_info.name,
                                type: 'lottery',
                                quantity: item.frequency,
                                img: 'feaddd50-c365-11eb-8b71-f188f515f7e9'
                            })
                        })
                    }
                }
                if (res.data.activity_reward && res.data.activity_reward.inviter_reward && res.data.activity_reward.inviter_reward.reward_mode === 'invite_people_number') {
                    self.inviterMode = 'invite_people_number';
                    if(res.data.activity_reward.inviter_reward.invite_people_reward.length) {
                        res.data.activity_reward.inviter_reward.invite_people_reward.forEach((item)=>{
                            self.inviteStep.push(item.invite_range_start)
                        })
                    }
                    self.inviteStep.push(res.data.activity_reward.inviter_reward.invite_people_reward[res.data.activity_reward.inviter_reward.invite_people_reward.length - 1].invite_range_end)
                    if (self.inviteStepActive < self.inviteStep.length) {
                        let inviteRewardListIndex = this.getRewardListIndex(this.inviteCount + 1);
                        if (inviteRewardListIndex >= 0) {
                            if (self.baseData.inviter_reward.invite_people_reward[inviteRewardListIndex].reward.coupons){
                                self.baseData.inviter_reward.invite_people_reward[inviteRewardListIndex].reward.coupons.forEach((item) => {
                                    if(item.coupon){
                                        this.rewardCoupons.push({
                                            rule: item.coupon.rule,
                                            name: item.coupon.name,
                                            type: 'coupon',
                                            quantity: item.quantity
                                        })
                                    }
                                })
                            }
                            if (self.baseData.inviter_reward.invite_people_reward[inviteRewardListIndex].reward.exchange_coupons){
                                self.baseData.inviter_reward.invite_people_reward[inviteRewardListIndex].reward.exchange_coupons.forEach((item) => {
                                    if(item.exchange){
                                        this.rewardExchangeCoupons.push({
                                            name: item.exchange.name,
                                            type: 'exchange_coupon',
                                            quantity: item.quantity
                                        })
                                    }
                                })
                            }
                            if (self.baseData.inviter_reward.invite_people_reward[inviteRewardListIndex].reward.goods_exchange_coupons){
                                self.baseData.inviter_reward.invite_people_reward[inviteRewardListIndex].reward.goods_exchange_coupons.forEach((item) => {
                                    if(item.exchange){
                                        this.rewardGoodExchangeCoupons.push({
                                            name: item.good_info.title,
                                            type: 'goods_exchange_coupon',
                                            quantity: item.quantity,
                                            img: 'feaddd50-c365-11eb-8b71-f188f515f7e9'
                                        })
                                    }
                                })
                            }
                            if (self.baseData.inviter_reward.invite_people_reward[inviteRewardListIndex].reward.lottery_activity) {
                                self.baseData.inviter_reward.invite_people_reward[inviteRewardListIndex].reward.lottery_activity.forEach((item) => {
                                    item.activity_id && this.rewardLottery.push({
                                        name: item.activity_info.name,
                                        type: 'lottery',
                                        quantity: item.frequency,
                                        img: 'feaddd50-c365-11eb-8b71-f188f515f7e9'
                                    })
                                })
                            }
                        }
                    }
                }
            });
        },
        methods: {
            getExchange(id) {
                return this.exchangeList[id];
            },
            shareToTimeline() {
                Dialog.alert({
                    message: '点击右上角即可分享到朋友圈',
                });
            },
            shareToMessage() {
                Dialog.alert({
                    message: '点击右上角即可分享给好友',
                });
            },
            showQccode() {
                this.isShowQccode = true;
            },
            getRewardText(config) {
                if (config.full_condition) {
                    return `满${config.full_condition}可用`
                } else if (config.max_deduction) {
                    return `最高可减${config.max_deduction}元`
                } else if (!config.full_condition) {
                    return `无门槛立减`
                }
            },
            getRewardListIndex(value) {
                let rewardIndex = '';
                this.baseData.inviter_reward.invite_people_reward.forEach((item, index) => {
                    if (value >= item.invite_range_start && value <= item.invite_range_end) {
                        rewardIndex = index;
                    }
                });
                if (rewardIndex === '') {return -1}
                else return rewardIndex;
            },
            activityRuleDialog() {
                let self = this
                Dialog.alert({
                    title: self.message.name,
                    message: `${self.message.explain}\n结束时间：${self.message.end_time}`,
                }).then(() => {
                });
            }
        }
    }
</script>

<style scoped>
    .main {
        height: 100%;
        max-width: 100%;
        overflow-x: hidden;
    }
    .bg-top {
        background-image: linear-gradient(#FF9E0F, #FFF8C1);
        max-width: 100%;
        height: 70%;
    }
    .main-title {
        display: flex;
        justify-content: center;
        width:100%;
        max-width: 100%;
        font-size: 1.3rem;
        font-family:'幼圆';
        color: #FFFFFF;
        opacity: 1;
    }
    .main-title-mini {
        padding: 5px; 
        text-align: center;
        max-width: 100%;
        font-size: 0.35rem;
        font-family: PingFang SC;
        color: #FFFFFF;
        opacity: 1;
    }
    .bg-img {
        width: 100%;
        margin-top: -2rem;
        padding:1rem 0;
    }
    .rewardBox {
        display:flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
    }
    .reward {
        width: 80%;
        height: 70px;
        background: #FFFFFF;
        box-shadow: 0px 2px 9px rgba(0, 0, 0, 0.04);
        opacity: 1;
        border-radius: 8px;
        display:flex;
        align-items: center;
        justify-content: center;
        margin: 5px;
        padding:15px;
    }
    .reward-icon {
        background-size: '100% 100%';
        width: 35%;
        float: left;
        height: 70px;
    }
    .reward-text {
        float: left;
        height: 70px;
        margin: 15px;
        display:flex;
        width: 65%;
        align-items: left;
        flex-direction: column;
        align-content: space-around;
    }

    .reward-text .text {
        font-size:0.3rem;
        flex: 1;
        display:flex;
        align-items:flex-end;
    }

    .intive-button {
        height: 55px;
        width: 300px;
        background: linear-gradient(90deg, #FFD789 0%, #FFCE46 100%);
        box-shadow: 0px 3px 0px #FF902C;
        opacity: 1;
        border-radius: 36px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .other-operate {
        height: 15px;
        width: 100%;
        margin:10px;
    }

    .other-operate .text {
        font-size: 0.3rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #BB3804;
        opacity: 1;
        display: flex;
        align-items: center;
        margin-bottom: 1rem;
    }
    .remarkText {
        color: #999999;
        font-weight: 500;
        text-align: center;
        font-size: '0.35rem';
        display: 'block'
    }
</style>



// WEBPACK FOOTER //
// src/pages/user/InviteCode.vue